<template>
  <div class="home">
    <div class="lan">
      <a :href="enUrl"><span>Chinese</span></a>
    </div>
    <div class="msgBox">
      <img :src="msg" style="width: 100%" />
    </div>
    <div class="homebtns">
      <div>
        <van-button round @click="visitorReg"   style="color:#188BFF;"
          >Visitor registration</van-button
        >
      </div>

    </div>
    <!-- 弹层 -->
<div v-if="showDialog" class="dialog">
  <div class="dialog-content">
    
    <p>Audience registration has closed!</p>
    
  </div>
</div>
  </div>
</template>
<script setup>
import msg from '@/assets/zh/msg.png'
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { showToast } from 'vant'
import api from '@/api/index.js'
import { decryptionECB } from '@/utils/utils.js'
import wx from '@/utils/wx.js'
const store = useStore()
const route = useRoute()
const invitesource = ref('')
const invitesourceID = ref('')
const lan = ref('')
const ExhCode = ref('')
import { onMounted } from 'vue'
const showDialog = ref(false)
const queryObj = route.query
// 邀请参数
if (queryObj.invitesource) {
  invitesource.value = queryObj.invitesource
  sessionStorage.setItem('invitesource', queryObj.invitesource)
}
if (queryObj.invitesourceID) {
  invitesourceID.value = queryObj.invitesourceID
  sessionStorage.setItem('invitesourceID', queryObj.invitesourceID)
}
if (queryObj.lan) {
  lan.value = queryObj.lan
  sessionStorage.setItem('lan', queryObj.lan)
}
if (queryObj.ExhCode) {
  ExhCode.value = queryObj.ExhCode
  store.commit('setExhCode', route.query.ExhCode)
} else {
  showToast({
    message: '展会参数缺失！',
    wordBreak: 'break-all',
    type: 'fail'
  })
}
// 英文链接地址
const enUrl = ref(
  `https://reg.alljoy.com.cn/VisitroRegist/26CEEC/#/login?ExhCode=${ExhCode.value}&lan=cn&invitesource=${invitesource.value}&invitesourceID=${invitesourceID.value}`
)
const isWeX = computed(() => store.state.isWeX)
if (/micromessenger/i.test(navigator.userAgent)) {
  store.commit('setIsWeX', true)
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalEValue
    })
  }
  document.title = configObj.ExhibitionName || ''
  return configObj
}

const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
  getGlobalConfig()
}
getToken()

const getGlobalConfig = async () => {
  const res = await api.getGConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const tmpObj = {}
    const resObj = JSON.parse(decryptionECB(res.data.configuartion))
    resObj.forEach((item) => {
      tmpObj[item.GlobalKey] = item.GlobalValue
    })
    store.commit('setGConfig', res.data.configuartion)
    store.commit('setMainColor', tmpObj.ButtonColor)
    // 判断展会是否关闭
    closeRes(gconfig.value.RegistStopTime)
    // closeRes('2023-02-04 14:00:00')
    if (isWeX.value) {
      wx.getWXSign()
    }
  }
}
const isClose = ref(false)
const closeRes = (str) => {
  const val = str.replace(/-/g, '/')
  isClose.value = new Date().getTime() >= new Date(val).getTime()
}

const router = useRouter()
const visitorReg = () => {
  router.push({
    path: '/loginForm',
    query: {
      invitesource: invitesource.value,
      invitesourceID: invitesourceID.value,
      lan: lan.value,
      ExhCode: ExhCode.value
    }
  })
}
</script>
<style lang="less" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  z-index: 999; /* 确保遮盖层在最上层 */
}
.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000; /* 确保弹层在遮盖层之上 */
  text-align: center;
}
.dialog-content {
  h3 {
    margin-bottom: 10px;
    font-size: 18px;
    color: #333;
  }

  p {
    margin-bottom: 10px;
    font-size: 20px;
    color: #666;
  }

  .van-button {
    width: 100px;
  }
}
.home {
  background: url('../../assets/zh/bg.png') no-repeat bottom center;
  background-size: cover;
  width: 100%;
   height: 100%;
  //height: 220vw;
  padding-top: 15vw;
  .lan {
    text-align: right;
    padding-right: 10vw;
    span {
      display: inline;
      background: #fff;
      font-size: 1em;
      width: 17vw;
      height: 5vw;
      line-height: 5vw;
      color: #0960b7;
      border-radius: 5px;
      display: inline-block;
      text-align: center;
    }
  }
  .msgBox {
    padding-top: 5vw;
    width: 80%;
    margin:0 auto;
  }
  .homebtns {
    text-align: center;
    padding-top: 45px;
    > div:nth-child(1) {
      padding-bottom: 4vw;
    }
    > div:nth-child(2) {
      padding-bottom: 10vw;
    }
    .van-button {
      width: 70vw;
      font-size: 19px;
      font-weight: 600;
    }
  }
}
@media screen and (min-width: 768px) {
  .home {
    height: 1600px;
    padding-top: 10px;
    .msgBox {
      padding-top: 50px;
    }
    .homebtns {
      .van-button {
        width: 70%;
      }
      & > div[data-v-07b13bd8]:nth-child(1) {
        padding-bottom: 30px;
      }
    }
    .lan {
      padding-left: 90px;
      span {
        width: 80px;
        height: 30px;
        line-height: 30px;
      }
    }
    .logins {
      .loginTit {
        font-size: 18px;
      }
    }
  }

}
</style>
